import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/user-nurse.svg'

@Component({
  tag: 'cr-icon-professional',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconProfessional {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }
}
